import AreaPage from "@/components/AreaPage";

const area = {
  name: "Sohna Road",
  slug: "water-tank-cleaning-sohna-road-gurugram",
  h1: "Water Tank Cleaning on Sohna Road, Gurugram",
  description: "Professional water tank cleaning on Sohna Road, Gurugram. Apartments, societies, and villas served with same-day service.",
  content1: "Sohna Road has emerged as one of Gurugram's fastest-growing residential corridors with numerous apartment complexes, gated communities, and affordable housing projects. TankBuddy serves all major societies along Sohna Road including CHD Avenue 71, Tulip Violet, Bestech Park View Spa, Eldeco Accolade, and many more. Our team handles both individual apartment tanks and large society-level underground and overhead tanks.",
  content2: "Given the rapid construction and mixed water sources (tanker + bore well + municipal) common along Sohna Road, regular tank cleaning every 6 months is especially critical for residents here. Sediment buildup from tanker water and bore well minerals can accumulate quickly, making professional cleaning essential for safe drinking water. TankBuddy offers affordable residential packages starting at just ₹999.",
  nearby: [
    { href: "/water-tank-cleaning-golf-course-road-gurugram", label: "Golf Course Road" },
    { href: "/water-tank-cleaning-sector-49-50-gurugram", label: "Sector 49-50" },
    { href: "/water-tank-cleaning-nirvana-country-gurugram", label: "Nirvana Country" },
    { href: "/water-tank-cleaning-sector-56-57-gurugram", label: "Sector 56-57" },
  ],
};

export default function SohnaRoadPage() {
  return <AreaPage area={area} />;
}
